import classNames from 'classnames';
import * as React from 'react';

import { CollapseButton } from '../../CollapseButton';
import * as styles from './RosreestrSection.css';

interface IRosreestrSectionProps {
  hasShowMoreButton: boolean;
  onShowMoreClick(): void;
  isRedesign?: boolean;
}

export const RosreestrSection: React.FC<IRosreestrSectionProps> = ({
  children,
  hasShowMoreButton,
  isRedesign,
  onShowMoreClick,
}) => {
  return (
    <div className={classNames(styles['container'], isRedesign && styles['redesign'])}>
      <div className={styles['title']}>Информация из Росреестра</div>
      {children}
      {hasShowMoreButton && (
        <div className={styles['button']}>
          <CollapseButton isCollapsed={hasShowMoreButton} collapsedText="Посмотреть всё" onClick={onShowMoreClick} />
        </div>
      )}
    </div>
  );
};
